const containerCls = "oaec1wglcug";
const textCls = "oaet6vq6gy";
const linkCls = "oaelfywtja";
const secondaryLinkCls = "oaespp2vbw";
const iconCls = "oaei16rorvm";

export { containerCls, iconCls, linkCls, secondaryLinkCls, textCls };
import "./message.access.style.linaria.module.css";
//# sourceMappingURL=message.access.style.js.map
